module.exports = __webpack_public_path__ + "img/banner.3f3c344.jpg";